<template>
  <div class="empty-container">
    <div class="empty-container__subheader">
      {{ $t("message.reviewBooster.placeholder.subtitle") }}
    </div>
    <ul class="feature-list">
      <li class="feature-list__el">
        <div class="feature-list__header">
          <div class="feature-list__icon icon-visibility"></div>
          <div class="feature-list__title">
            {{
              $t("message.reviewBooster.placeholder.list.firstElement.title")
            }}
          </div>
        </div>
        <div class="feature-list__text">
          {{
            $t(
              "message.reviewBooster.placeholder.list.firstElement.description"
            )
          }}
        </div>
      </li>
      <li class="feature-list__el">
        <div class="feature-list__header">
          <div class="feature-list__icon icon-money"></div>
          <div class="feature-list__title">
            {{
              $t("message.reviewBooster.placeholder.list.secondElement.title")
            }}
          </div>
        </div>
        <div class="feature-list__text">
          {{
            $t(
              "message.reviewBooster.placeholder.list.secondElement.description"
            )
          }}
        </div>
      </li>
      <li class="feature-list__el">
        <div class="feature-list__header">
          <div class="feature-list__icon icon-time"></div>
          <div class="feature-list__title">
            {{
              $t("message.reviewBooster.placeholder.list.thirdElement.title")
            }}
          </div>
        </div>
        <div class="feature-list__text">
          {{
            $t(
              "message.reviewBooster.placeholder.list.thirdElement.description"
            )
          }}
        </div>
      </li>
    </ul>
    <div class="screen-container">
      <div class="screen-container__title">
        {{ $t("message.reviewBooster.placeholder.positiveScreenList.title") }}
      </div>
      <ul class="screen-list">
        <li class="screen-list__item">
          <div class="screen-list__img">
            <img
              :src="
                require(`@/static/review-booster/${selectedLocale}/form.svg`)
              "
            />
          </div>

          <div class="screen-list__label">
            {{
              $t(
                "message.reviewBooster.placeholder.positiveScreenList.firstElement"
              )
            }}
          </div>
        </li>
        <li class="screen-list__item">
          <div class="screen-list__img">
            <img
              :src="
                require(`@/static/review-booster/${selectedLocale}/end-screen.svg`)
              "
            />
          </div>
          <div class="screen-list__label">
            {{
              $t(
                "message.reviewBooster.placeholder.positiveScreenList.secondElement"
              )
            }}
          </div>
        </li>
        <li class="screen-list__item">
          <div class="screen-list__img">
            <img
              :src="
                require(`@/static/review-booster/${selectedLocale}/review.svg`)
              "
            />
          </div>
          <div class="screen-list__label">
            {{
              $t(
                "message.reviewBooster.placeholder.positiveScreenList.thirdElement"
              )
            }}
          </div>
        </li>
      </ul>
    </div>
    <div class="screen-container">
      <div class="screen-container__title">
        {{ $t("message.reviewBooster.placeholder.negativeScreenList.title") }}
      </div>
      <ul class="screen-list">
        <li class="screen-list__item">
          <div class="screen-list__img">
            <img
              :src="
                require(`@/static/review-booster/${selectedLocale}/negative-form.svg`)
              "
            />
          </div>
          <div class="screen-list__label">
            {{
              $t(
                "message.reviewBooster.placeholder.negativeScreenList.firstElement"
              )
            }}
          </div>
        </li>
        <li class="screen-list__item">
          <div class="screen-list__img">
            <img
              :src="
                require(`@/static/review-booster/${selectedLocale}/negative-review.svg`)
              "
            />
          </div>
          <div class="screen-list__label">
            {{
              $t(
                "message.reviewBooster.placeholder.negativeScreenList.secondElement"
              )
            }}
          </div>
        </li>
        <li class="screen-list__item">
          <div class="screen-list__img">
            <img
              :src="
                require(`@/static/review-booster/${selectedLocale}/negative-end-screen.svg`)
              "
            />
          </div>
          <div class="screen-list__label">
            {{
              $t(
                "message.reviewBooster.placeholder.negativeScreenList.thirdElement"
              )
            }}
          </div>
        </li>
      </ul>
    </div>
    <div class="contact">
      <div class="contact__title">
        {{ $t("message.reviewBooster.placeholder.contactText") }}
      </div>
      <div class="contact__tile">
        <div class="contact__avatar"></div>
        <div class="contact__list">
          <div class="contact__name">
            {{ $t("message.storeLocator.placeholder.consultantName") }}
          </div>
          <div class="contact__data">
            {{ $t("message.storeLocator.placeholder.phone") }}
          </div>
          <div class="contact__data">
            <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/config/constants";
import { LOCALE } from "@/enums/locale";
import { mapState } from "vuex";

export default {
  name: "ReviewBoosterConfigEmpty",
  data: () => ({
    supportEmail: constants.supportEmail
  }),
  computed: {
    ...mapState({
      selectedLocale: state => state.settings.selectedLocale || LOCALE.PL
    })
  }
};
</script>

<style lang="scss" scoped src="./ConfigEmpty.scss"></style>
